import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function MRFIssueDashboard() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const user = JSON.parse(
    localStorage.getItem("user") || "{}"
  );
useEffect(() => {
    loadMRFs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.company_id]);

  const loadMRFs = async () => {
    try {
      if (!user.company_id) return;

      const q = query(
        collection(db, "material_requests"),
        where("company_id", "==", user.company_id),
        orderBy("created_at", "desc")
      );

      const snap = await getDocs(q);

      const list = snap.docs.map((doc) => ({
  id: doc.id,
  ...doc.data()
}));

setRequests(list);

    } catch (error) {
      console.error("MRF Dashboard Error:", error);

      try {
        const fallbackSnap = await getDocs(
  query(collection(db, "material_requests"),
  where("company_id", "==", user.company_id))
);

        const fallbackList = fallbackSnap.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data()
          }))
          .filter(
            (item) =>
              !user.company_id ||
              item.company_id === user.company_id
          )
          .sort((a, b) => {
            const aTime = a.created_at?.seconds || 0;
            const bTime = b.created_at?.seconds || 0;
            return bTime - aTime;
          });

        setRequests(fallbackList);

      } catch (fallbackError) {
        console.error(
          "Fallback MRF Error:",
          fallbackError
        );
      }

    } finally {
      setLoading(false);
    }
  };

  const getStatusTheme = (status) => {
  switch ((status || "").toLowerCase()) {
    case "pending":
      return {
        card: "bg-gradient-to-r from-amber-50 via-yellow-50 to-orange-50 border border-amber-200",
        badge: "bg-amber-100 text-amber-700",
        arrow: "text-amber-500"
      };

    case "approved":
      return {
        card: "bg-gradient-to-r from-indigo-50 via-blue-50 to-sky-50 border border-indigo-200",
        badge: "bg-indigo-100 text-indigo-700",
        arrow: "text-indigo-500"
      };

    case "partially_issued":
      return {
        card: "bg-gradient-to-r from-orange-50 via-rose-50 to-pink-50 border border-orange-200",
        badge: "bg-orange-100 text-orange-700",
        arrow: "text-orange-500"
      };

    case "issued":
      return {
        card: "bg-gradient-to-r from-emerald-50 via-green-50 to-lime-50 border border-emerald-300",
        badge: "bg-emerald-100 text-emerald-800",
        arrow: "text-emerald-600"
      };

    case "rejected":
      return {
        card: "bg-gradient-to-r from-rose-50 via-red-50 to-pink-50 border border-rose-200",
        badge: "bg-rose-100 text-rose-700",
        arrow: "text-rose-500"
      };

    default:
      return {
        card: "bg-gradient-to-r from-gray-50 to-slate-50 border border-gray-200",
        badge: "bg-gray-100 text-gray-700",
        arrow: "text-gray-500"
      };
  }
};

  if (loading) {
    return (
      <div className="p-6 text-lg font-semibold text-gray-600">
        Loading MRF Dashboard...
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8">
        MRF Issue Dashboard
      </h1>

      {requests.length === 0 ? (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-gray-500">
          No material requests found.
        </div>
      ) : (
        <div className="space-y-4">
          {requests.map((req) => {
            const theme = getStatusTheme(req.status);

            return (
              <div
                key={req.id}
                onClick={() =>
                  navigate(`/store-mrf/${req.id}`)
                }
                className={`
                  ${theme.card}
                  rounded-2xl
                  px-6
                  py-5
                  shadow-sm
                  hover:shadow-xl
                  hover:scale-[1.01]
                  transition-all
                  duration-300
                  cursor-pointer
                `}
              >
                <div className="flex justify-between items-center">
                  
                  {/* LEFT */}
                  <div className="flex items-center gap-8 flex-wrap">
                    
                    <div>
                      <h2 className="text-xl md:text-2xl font-semibold text-slate-800 tracking-tight">
                        {req.site_name ||
                          req.project_name ||
                          req.client_name ||
                          "Unknown Project"}
                      </h2>
                    </div>

                    <div className="text-sm text-gray-600 font-medium">
                      {req.reviewed_items?.length ||
                        req.items?.length ||
                        0} items
                    </div>

                    <div className="text-sm text-gray-500">
                      {req.created_at?.seconds
                        ? new Date(
                            req.created_at.seconds * 1000
                          ).toLocaleString()
                        : "-"}
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="flex items-center gap-4">
                    
                    <span
                      className={`
                        ${theme.badge}
                        px-4
                        py-2
                        rounded-full
                        text-xs
                        font-bold
                        uppercase
                        tracking-wide
                      `}
                    >
                      {req.status || "pending"}
                    </span>

                    <ChevronRight
                      size={28}
                      className={`${theme.arrow}`}
                    />
                  </div>

                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}